import { Component, Input, OnInit } from '@angular/core'
//import universityLogoFull from 'src/assets/logo_full.svg'
//import universityLogoSmall from 'src/assets/logo_small.svg'

@Component({
  selector: 'mu-university-logo',
  styleUrls: ['./mu-university-logo.component.scss'],
  templateUrl: './mu-university-logo.component.html',
})
// tslint:disable-next-line:component-class-suffix
export class MuUniversityLogo implements OnInit {
  @Input() variant: 'full' | 'small' = 'full'
  @Input() color: 'dark' | 'light' = 'light'
  universityLogo: string

  constructor() {}

  ngOnInit() {
    switch (this.variant) {
      case 'full': {
        return (this.universityLogo = 'assets/logo_full.svg')
      }
      default:
        this.universityLogo = 'assets/logo_small.svg'
    }
  }
}
